import { useNavigate, useParams } from "react-router";
import { Container, Row, Col, Card, Button, Accordion } from "react-bootstrap";
import { ArrowDown } from "react-bootstrap-icons";
import React, { useEffect } from "react";

import { getTexts, selectTexts } from "../../redux/reducers/textSlice";
import { getConditions, selectConditions } from "../../redux/reducers/conditionSlice";
import { getPauses, selectPauses } from "../../redux/reducers/pauseSlice";
import {
    getProcedureConfig,
    getStudy,
    getStudySetupInfo,
    selectStudy,
    selectStudySetupInfo,
    selectStudyProcedure,
    updateStudy,
    generateProcedures,
    generateParticipants,
    // populateSurveyParticipants,
    selectStudyProcedureOverview,
    getProcedureConfigOverview,
} from "../../redux/reducers/studySlice";
import { useDispatch, useSelector } from "react-redux";

import Topbar from "../../components/Topbar";
import LoadingScreen from "../../components/LoadingScreen";
import { reformatDate } from "../../components/CommonFunctions";
import ShowProcedure from "./ShowProcedure";
import StudyCreationLayout, { CreationSteps, StudyStatus, isStudyOver } from "./navigation_logic/StudyCreationLayout";
import { STATES } from "../study_overview/StudyOverviewLayout";


export default function CreateCheck(props) {
    const { status } = props
    const { study_id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const study = useSelector(selectStudy)
    const studySetupInfo = useSelector(selectStudySetupInfo)
    const texts = useSelector(selectTexts)
    const conditions = useSelector(selectConditions)
    const pauses = useSelector(selectPauses)
    const procedureConfig = useSelector(selectStudyProcedure)
    const procedureConfigOverview = useSelector(selectStudyProcedureOverview)

    // Lock a launched (Active) study only while it is still live; an over study
    // can be edited again.
    const disabled = status === StudyStatus.Active && !isStudyOver(study)

    useEffect(  () => {
        dispatch(getStudy(study_id))
        dispatch(getStudySetupInfo(study_id))
        dispatch(getProcedureConfig(study_id)).then((response) => {
            if (response.payload.body.id) {
                dispatch(getProcedureConfigOverview(response.payload.body.id))
            }
        })

    }, [])

    if (study == null || studySetupInfo == null || procedureConfig == null || procedureConfigOverview == null) {
        return (
            <>
                <Topbar />
                <LoadingScreen />
            </>
        )
    }

    const handleFinish = async (event) => {
        event.preventDefault()

        // let procedureScheme = studySetupInfo.planned_procedure.map(step =>
        //     step.condition_id == null ? step : {"dummy": true}
        // )

        if (study.state === STATES.SETUP) {
            await dispatch(generateProcedures(study_id))

            await dispatch(generateParticipants({
                "studyId": study_id,
                "amount": studySetupInfo.planned_number_participants
            }))
        }

        // DEPRECATED
        // if (studySetupInfo.planned_procedure.findIndex(step => step.questionnaire_id != null) > -1) {
        //     await dispatch(populateSurveyParticipants(study_id))
        // }

        // check if start date is today
        let updateState = STATES.FINISHED
        if (new Date(study.startDate.split('T')[0]) <= new Date()) updateState = STATES.RUNNING

        await dispatch(updateStudy({
            "studyId": study_id,
            "study": {
                "state": updateState, // "setup", "running", "finished"
                "current_setup_step": "check"
            }
        }))
        navigate("/study/" + study_id + "/overview")
    }

    return (
        <StudyCreationLayout step={CreationSteps.Check}>
            <Container>
                <Row>
                    {
                        disabled ?
                            <Col className="mb-4">Please check your changes.</Col>
                            :
                            <Col className="mb-4">Please check your input. You cannot edit the procedure order after creating the study.</Col>
                    }
                </Row>
            </Container>

            <Container>
                <h4 className="mb-3">Study Details</h4>
                <Row>
                    <Col xs={3}> <b> Name: </b> </Col>
                    <Col> {study.name} </Col>
                </Row>
                <Row>
                    <Col xs={3}> <b> Private Study: </b> </Col>
                    <Col> {study.invite_only ? "Yes" : "No"} </Col>
                </Row>
                <Row>
                    <Col xs={3}> <b> Start Date: </b> </Col>
                    <Col> {reformatDate(study.startDate)} </Col>
                </Row>
                <Row>
                    <Col xs={3}> <b> End Date: </b> </Col>
                    <Col> {reformatDate(study.endDate)} </Col>
                </Row>
                <Row>
                    <Col xs={3}> <b> Planned Participants: </b> </Col>
                    <Col> {studySetupInfo.planned_number_participants} </Col>
                </Row>

                {/* Description & consent as open boxes, matching the study details view. */}
                <Accordion defaultActiveKey={["description", "consent"]} alwaysOpen className="mt-4">
                    <Accordion.Item eventKey="description">
                        <Accordion.Header>Description</Accordion.Header>
                        <Accordion.Body>
                            <div
                                className="description-content"
                                dangerouslySetInnerHTML={{ __html: study.description }}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="consent">
                        <Accordion.Header>Consent</Accordion.Header>
                        <Accordion.Body>
                            <div
                                className="consent-content"
                                dangerouslySetInnerHTML={{ __html: study.consent }}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <Row className="mt-4 align-items-center">
                    <Col> <h4 className="mb-0"> Procedure </h4></Col>
                    <Col xs="auto" className="text-muted small d-flex align-items-center gap-1">
                        counterbalanced <ArrowDown />
                    </Col>
                </Row>
                <Row>
                    <ShowProcedure procedureId={procedureConfig && procedureConfig.id} />
                </Row>

                <Row className='mt-4' xs="auto">
                    <Button size="lg" onClick={handleFinish}>Finish</Button>
                </Row>
            </Container>

        </StudyCreationLayout>
    )
}